import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ServiceCategories from "./sections/ServiceCategories";
import GetStarted from "./sections/GetStarted";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <ServiceCategories />
      <GetStarted />
      <Footer />
    </div>;
}